<div class="my-bg-gradient m-0 p-0 w-100 min-vh-100 max-vh-100">
  <app-alert></app-alert>

  <div
    class="d-flex flex-column align-items-stretch align-content-stretch min-vh-100 max-vh-100">
    <div class="d-lg-none sticky-horizontal">
      <app-sidebar [isMobile]="true" />
    </div>

    <div class="d-none d-lg-block sidebar-custom">
      <app-sidebar [isMobile]="false" />
    </div>

    <div
      class="d-flex flex-column col g-0"
      [style.marginLeft.px]="sidebarWidth()"
      [ngStyle]="{ 'max-width': contentMaxWidth }">
      <main id="main-content" role="main" class="flex-grow-1">
        <router-outlet></router-outlet>
      </main>

      <app-footer [marginLeft]="sidebarWidth()" />
    </div>
  </div>
</div>
